import { FC } from 'react'
import classNames from 'classnames'

export interface AppSmallButtonProps {
  type?: AppSmallButtonType
  disabled?: boolean
  className?: string
  onClick: () => void
}

export type AppSmallButtonType = 'info' | 'error' | 'clear'

export const AppSmallButton: FC<AppSmallButtonProps> = ({
  onClick,
  children,
  type = 'info',
  disabled = false,
  className,
}) => {
  className = classNames({
    'w-[30px] h-[30px] flex justify-center items-center text-2xl font-semibold border-none rounded-xl duration-200':
      true,
    'text-white bg-orange hover:bg-orange-hover': type === 'info' && !disabled,
    'text-white text-opacity-50 bg-orange-disabled cursor-not-allowed': type === 'info' && disabled,
    'text-black bg-orange-soft hover:bg-orange-soft-hover': type === 'clear' && !disabled,
    'text-black text-opacity-50 bg-orange-soft cursor-not-allowed': type === 'clear' && disabled,
    'text-white bg-red-button hover:bg-red-button-hover': type === 'error' && !disabled,
    'text-white text-opacity-50 bg-red-button-disabled cursor-not-allowed': type === 'error' && disabled,
    [className ? className : '']: true,
  })

  return (
    <button
      className={className}
      disabled={disabled}
      onClick={e => {
        onClick()
        e.stopPropagation()
      }}
    >
      {children}
    </button>
  )
}
